import { render, staticRenderFns } from "./SearchReportResident.vue?vue&type=template&id=0aff7751&"
import script from "./SearchReportResident.vue?vue&type=script&lang=js&"
export * from "./SearchReportResident.vue?vue&type=script&lang=js&"
import style0 from "./SearchReportResident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports